// import NoLoginLayout from "@/components/layout/admin/NoLoginLayout.vue";
import { required, email, minLength } from "vuelidate/lib/validators";
import store from "@/store";
import axios from "axios";
import MainLayout from "@/components/layout/company/MainLayout.vue";

export default {
    name: "companyLogin",
    
    components: {
        // NoLoginLayout,
        MainLayout
    },

    data() {
        return {
            loginForm: {
                email: this.email,
                password: this.password
            },
            submitted: false
        };
    },

    validations: {
        loginForm: {
            email: {
                required,
                email
            },
            password: {
                required,
                minLength: minLength(6)
            }
        }
    },

    methods: {
        submitLogin() {
            this.submitted = true;
            if (this.$v.loginForm.$invalid) {
                return;
            }
            this.loginCompany();
        },

        loginCompany() {
           store.dispatch("companyLogin", {
                    email: this.loginForm.email,
                    password: this.loginForm.password,
                })
                .then(() => {
                    this.$router.push({
                        name: "companyIndex"
                    });
                    location.reload();
                })
                .catch(error => {
                    this.$notification.error("သင့် အီးမေးလ်လိပ်စာနှင့် စကားဝှက်ကို ပြန်လည်စစ်ဆေးပေးပါ။", {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                    console.log("login error", error);
                });
        },

        AuthProvider(provider) {
            this.$auth.authenticate(provider)
                .then(response => {
                    this.facebookLogin(provider, response);
                })
                .catch(err => {
                    console.log({
                        err: err
                    });
                });
        },

        facebookLogin(provider, response) {
            axios.post('/company/facebooklogin/' + provider, response)
                .then(response => {
                    if (response.data.data.token) {
                        store.commit("setCompanyData", response.data.data);
                        this.$router.push({
                            name: 'companyIndex'
                        });
                        location.reload();
                    } else {
                        this.$router.push({
                            name: "companyRegister",
                            params: {
                                data: response.data.data
                            }
                        });
                        this.$notification.success("Please Signup First", {
                            timer: 2,
                            position: "bottomCenter"
                        });
                        setTimeout(() => this.$router.push({
                            name: "companyRegister",
                            params: {
                                data: response.data.data
                            }
                        }), 2000);
                    }
                })
                .catch(error => {
                    console.log("Facebook Login Error", error);
                });
        }
    },
    mounted() {
        const email = localStorage.getItem('companyEmail');
        if (email) {
            this.loginForm.email = email;
        } else {
            this.loginForm.email = null;
        }
    }

};
